import { VWO } from './vwo.js';

(() => {
    document.querySelectorAll('[data-track-click]').forEach((el) =>
        el.addEventListener('click', () => {
            VWO.event(el.dataset.trackClick);
        })
    );
})();
